import {ShadowBox, XStack, YStack, DashedBadge, Separator, Button} from "@chayka/ui";
import type {trpc} from "@/app/trpc";
import {ServiceVerboseBottomSheet} from "../ServiceVerboseBottomSheet";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "@/hooks/useAuth";

interface ServiceCardProps {
  service: (typeof trpc.rooms.list)["~types"]["output"]["drums"][number];
}

export const ServiceCard: React.FC<ServiceCardProps> = ({service}) => {
  const [isBottomSheetOpen, setBottomSheetOpen] = useState(false);

  const navigate = useNavigate();
  const {isAuthenticated, user} = useAuth();

  return (
    <>
      <ShadowBox className="rounded-xl p-4">
        <YStack className="gap-4">
          <DashedBadge>{service.name}</DashedBadge>

          <YStack className="gap-1">
            <div className="font-bold">Тип занятия:</div>
            <XStack className="gap-2 flex-wrap">
              {service.bookingTypes.map((type) => (
                <div
                  className="whitespace-nowrap text-sm border border-stroke px-2 py-1 rounded-full"
                  key={type}
                >
                  {type}
                </div>
              ))}
            </XStack>
          </YStack>

          <YStack className="gap-1">
            <div className="font-bold">Площадь: {service.square} м²</div>
            <div className="text-sm">
              Комфортно для {service.capacity} человек{service.capacity > 1 ? "" : "а"}
            </div>
          </YStack>

          <div className="font-bold text-xl self-end">
            {service.isPriceMinimum && "от "}
            {service.price} ₽ в час
          </div>

          <Separator />

          <XStack className="gap-2">
            <Button
              size="small"
              className="flex-1"
              variant="secondary"
              onClick={() => setBottomSheetOpen(true)}
            >
              Подробнее
            </Button>
            <Button
              size="small"
              className="flex-1"
              onClick={() => navigate(`/app/booking?roomId=${service.id}`)}
              disabled={!isAuthenticated || user?.confirmationStatus !== "approved"}
            >
              Забронировать
            </Button>
          </XStack>
        </YStack>
      </ShadowBox>
      <ServiceVerboseBottomSheet
        isOpen={isBottomSheetOpen}
        onClose={() => setBottomSheetOpen(false)}
        service={service}
      />
    </>
  );
};
